import React from 'react'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import Pembayaran from './pembayaran'
import Alamat from './alamat'
import TarikSaldo from './tarikSaldo'
import walletService from '../Service/walletService'

export default class UserProfiles extends React.Component {
    constructor() {
        super()
        this.state = {
            displayTarik: "none",
            Wallet:{}
        }
    }
    loadList = async () => {
        const responWalet = await walletService.getAll(localStorage.getItem(config.userid))
        // console.log(responCount)
        if (responWalet.result != undefined) {
            this.setState({
                Wallet: responWalet.result,
            }, () => {
                if (this.state.Wallet.is_delete == false) {
                    this.setState({
                        displayTarik: ""
                    })
                }
            })
        }
    }
    componentDidMount() {
        this.loadList()
    }
    // console.log(this.List)

    render() {
        const { changehandler, ModelBio, ModelPassword, setShowPassNow, setShowPassNew,
            setShowBio, addHandlerBio, cancelHandlerBio, errors, changehandlerpassword,
            saveHandlerBio, onLogout, cancelHandlerOtp, addOldPass, cancelNewPass,
            addHandlerEmail, cancelHandlerEmail, cancelOldPass, oldpasswordhandler, updPhoto,
            changehandleremail, otpHandler, setShowEmail, updPassword, tooglehandler, type,
            ModelAkun, setShowOtp, resendotpHandler, updEmail, href, setShowPhoto, handleUpload, imagehandle,
            editPhoto, cancelPhoto, progress
        } = this.props
        const { displayTarik } = this.state
        return (
            <div>
                <div id="recaptcha"></div>
                <div class="content">
                    <div class="row">
                        <div class="col-sm-7 col-6">
                            <h4 class="page-title">My Profile</h4>
                        </div>

                        {/* <div class="col-sm-5 col-6 text-right m-b-30">
                        <a href="edit-profile.html" class="btn btn-primary btn-rounded"><i class="fa fa-plus"></i> Edit Profile</a>
                    </div> */}
                    </div>
                    <div class="row">
                        <div class="col-md-6"  >
                            <div class="card-box " style={{ width: "400px", height: "690px", margin: "0 0 0 30px", alignContent: "center" }}>
                                <div class="col-md-4" style={{ padding: "0 160px" }}>
                                    <a class="btn btn-primary edit-btn" onClick={editPhoto}><i class="fa fa-pencil" style={{ color: "white" }}></i></a>
                                </div>
                                <div class="col-md-2" style={{ margin: "0 100px" }}>
                                    <div class="profile-img">
                                        <a href="#"><img class="avatar" src={ModelBio.image_path} style={{ width: "200px", height: "200px", margin: "0 0 0 -50px" }} alt="" /></a>

                                        <div style={{ width: "200px", margin: "10px 0 0 -50px" }}>
                                            <h4 style={{ textAlign: "center" }}>{localStorage.getItem(config.username)}</h4>
                                            <div class='text-center'>
                                                <i class="fa fa-star bintang mb-2"></i>
                                                <h3 >Bronze Member</h3>
                                                <h3 class="card-title">Since 2021</h3> <br />
                                            </div>
                                            <a href="/pasien"><h4 style={{ marginBottom: "-10px" }}>Pasien</h4></a>
                                            <br></br>
                                            <a href="konsultasi.html"><h4 style={{ marginBottom: "-10px" }}>Pembelian Obat</h4></a>
                                            <br></br>
                                            <a href="/rencana_kedatangan"><h4 style={{ marginBottom: "-10px" }}>Rencana Kedatangan</h4></a>
                                            <br></br>
                                            <a href="rencana_kedatangan.html"><h4>Riwayat Chat Dokter</h4></a>
                                        </div>
                                        <div style={{ margin: "50px 0 0 0" }} >.</div>
                                    </div>
                                    <div style={{ margin: "50px 0 0 0" }} >.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6" style={{ margin: "0 0 0 -180px" }}>
                            <div class="profile-tabs">
                                <ul class="nav nav-tabs nav-tabs-bottom">
                                    <li class="nav-item"><a class="nav-link show" href="#about-cont" data-toggle="tab">Profil</a></li>
                                    <li class="nav-item"><a class="nav-link show active" href="#alamat-cont" data-toggle="tab">Alamat</a></li>
                                    <li class="nav-item"><a class="nav-link show" href="#pembayaran-cont" data-toggle="tab">Pembayaran</a></li>
                                    <li class="nav-item"><a class="nav-link show" href="#penarikan-cont" data-toggle="tab" style={{ display: `${displayTarik}` }}>Tarik Saldo</a></li>
                                </ul>

                                <div class="tab-content">
                                    <div class="tab-pane show" id="about-cont">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="card-box" >
                                                    <h4 class="card-title" style={{ padding: "0 200px 0 200px" }}>Data Pribadi <a href="#modal_biodata"
                                                        class="btn btn-primary edit-btn" onClick={addHandlerBio} style={{ margin: "0 200px 0 200px" }}><i class="fa fa-pencil" style={{ color: "white" }}></i></a></h4>

                                                    <div class="form-group" style={{ padding: "0 200px 0 200px" }}>
                                                        <label>Nama Lengkap:</label>
                                                        <input type="text" class="form-control" style={{
                                                            borderBottom: "solid blue 1px",
                                                            borderLeft: "hidden", borderRight: "hidden", borderTop: "hidden"
                                                        }} value={ModelBio.name} />
                                                    </div>
                                                    <div class="form-group" style={{ padding: "0 200px 0 200px" }}>
                                                        <label>Tanggal Lahir:</label>
                                                        <input type="text" class="form-control" style={{
                                                            borderBottom: "solid blue 1px",
                                                            borderLeft: "hidden", borderRight: "hidden", borderTop: "hidden"
                                                        }} value={ModelBio.tgl_lahir} />
                                                    </div>
                                                    <div class="form-group" style={{ padding: "0 200px 0 200px" }}>
                                                        <label>No.Hp:</label>
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon1" >+62</span>
                                                            <input type="text" class="form-control" style={{
                                                                borderBottom: "solid blue 1px",
                                                                borderLeft: "hidden", borderRight: "hidden", borderTop: "hidden"
                                                            }} value={(ModelBio.mobile)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-box" >
                                                    <h4 class="card-title" style={{ padding: "0 200px 0 200px" }}>Data Akun </h4>

                                                    <div class="form-group" style={{ padding: "0 200px 0 200px" }}>
                                                        <span><a href="#email_edit" onClick={addHandlerEmail} class="btn btn-primary edit-btn" style={{ margin: "40px 200px 0 200px" }}><i class="fa fa-pencil" style={{ color: "white" }}></i></a></span>
                                                        <label>Email:</label>
                                                        <input type="text" class="form-control" style={{
                                                            borderBottom: "solid blue 1px",
                                                            borderLeft: "hidden", borderRight: "hidden", borderTop: "hidden"
                                                        }} value={ModelAkun.email} />
                                                    </div>
                                                    <span><a href="#edit_password" onClick={addOldPass} class="btn btn-primary edit-btn" style={{ margin: "125px 200px 0 200px" }}><i class="fa fa-pencil" style={{ color: "white" }}></i></a>
                                                    </span>
                                                    <div class="form-group" style={{ padding: "0 200px 0 200px" }}>
                                                        <label>Password:</label>
                                                        <input type={type} class="form-control" style={{
                                                            borderBottom: "solid blue 1px",
                                                            borderLeft: "hidden",
                                                            borderRight: "hidden",
                                                            borderTop: "hidden",
                                                        }} value={ModelAkun.password} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="tab-pane show " id="alamat-cont" >
                                        <Alamat />
                                    </div>
                                    <div class="tab-pane show " id="pembayaran-cont">

                                        <Pembayaran
                                            mobileOtp={this.mobileOtp}
                                        />
                                    </div>
                                    <div class="tab-pane show " id="penarikan-cont" >
                                        <TarikSaldo
                                        balance={this.state.Wallet.balance}
                                        pin={this.state.Wallet.pin} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="modal_biodata">
                    <Modal show={setShowBio} >
                        <Modal.Header>
                            <Modal.Title>Edit Biodata</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>Nama Lengkap</label>
                                <input type="text" class="form-control" style={{ border: "solid blue 1px" }} value={ModelBio.name} id="name" onChange={changehandler("name")} />
                                <span className="error"> {errors["name"]}</span>
                            </div>
                            <div class="form-group">
                                <label for="">No.Hp</label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">+62</span>
                                    <input type="number" class="form-control" style={{ border: "solid blue 1px" }} value={(ModelBio.mobile)} id="mobile" onChange={changehandler("mobile")} />
                                </div>
                                <span className="error"> {errors["mobile"]}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Tanggal Lahir</label>
                                <input type="date" class="form-control" style={{ border: "solid blue 1px" }} value={ModelBio.tgl_lahir} id="tgl_lahir" onChange={changehandler("tgl_lahir")} />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" onClick={saveHandlerBio} >Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelHandlerBio} >Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div id="email_edit">
                    <Modal show={setShowEmail} >
                        <Modal.Header>
                            <Modal.Title>Edit Email</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" class="form-control" style={{ border: "solid blue 1px" }} value={ModelAkun.email} id="email" onChange={changehandleremail("email")} />
                                <span className="error"> {errors["email"]}</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" href="#otp" onClick={otpHandler} >Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelHandlerEmail} >Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div id="otp">
                    <Modal show={setShowOtp} >
                        <Modal.Header>
                            <Modal.Title>Enter otp</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>Enter code that we send to your email</label>
                                <input type="number" class="form-control" style={{ border: "solid blue 1px" }} value={ModelAkun.otp} id="otp" onChange={changehandleremail("otp")} />
                                <span className="error"> {errors["otp"]}</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>

                            <button type="button" class="btn btn-primary" id="buttotp" style={{ display: "none" }} onClick={resendotpHandler}>Resend</button>
                            <button type="button" class="btn btn-primary" onClick={updEmail}>Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelHandlerOtp}>Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div id="edit_password">
                    <Modal show={setShowPassNow} >
                        <Modal.Header>
                            <Modal.Title>Edit Password</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>Password saat ini</label>
                                <input type={type} class="form-control" style={{ border: "solid blue 1px" }}
                                    value={ModelPassword.password} onChange={changehandlerpassword("password")} />
                                <span className="error"> {errors["password"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Masukkan ulang password</label>
                                <input type={type} class="form-control" style={{ border: "solid blue 1px" }} value={ModelPassword.password_confirm} onChange={changehandlerpassword("password_confirm")} />
                                <span className="error"> {errors["password_confirm"]}</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" href={href} onClick={oldpasswordhandler} >Submit</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelOldPass} >Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div id="edit-password-new">
                    <Modal show={setShowPassNew} >
                        <Modal.Header>
                            <Modal.Title>New Password</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>New Password</label>
                                <input type={type} class="form-control" style={{ border: "solid blue 1px" }} value={ModelPassword.new_password} id="password" onChange={changehandlerpassword("new_password")} />
                                <span className="error"> {errors["new_password"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Masukkan ulang password</label>
                                <input type={type} class="form-control" style={{ border: "solid blue 1px" }} value={ModelPassword.new_password_confirm} id="password" onChange={changehandlerpassword("new_password_confirm")} />
                                <span className="error"> {errors["new_password_confirm"]}</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" onClick={updPassword}>Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelNewPass}>Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div id="edit_photo">
                    <Modal show={setShowPhoto} >
                        <Modal.Header>
                            <Modal.Title>Edit Photo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>File</label>
                                <input type="file" class="form-control-file" onChange={imagehandle} />
                                <span className="error"> {errors["photo"]}</span>
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" style={{ width: (parseInt(progress) + "%") }}></div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" onClick={handleUpload} >Upload</button>
                            <button type="button" class="btn btn-primary" onClick={updPhoto} >Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelPhoto} >Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>


            </div>

        )
    }
}